"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeMapUpdatesButtonContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const RealtimeMapUpdatesButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  height: 2.4rem;
  position: relative;
  background-color: ${colors_1.white};
  box-shadow: 2px 2px 4px 0px ${colors_1.gray900};
  border-radius: 0.5rem;
  padding: 0 0.9rem;

  @media ${media_1.media.smallDesktop} {
    font-size: 1.4rem;
    height: 4.2rem;
    padding: 0 1.6rem;
    border-radius: 1rem;
  }
`;
exports.RealtimeMapUpdatesButtonContainer = RealtimeMapUpdatesButtonContainer;
